/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";

import { Col } from "reactstrap";

import "./HorizontalTimeline.scss";

import "react-perfect-scrollbar/dist/css/styles.css";

//i18n
import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";

// Moment
import * as moment from "moment";
import "moment-duration-format";
import { convertSlaTime } from "../../../../../../../Libs/CustomMethods/customMethods";

const HorizontalTimeline = ({ time, ...props }) => {
  const { t } = useTranslation();
  
  const timeF = useMemo(() => {
    if (time === -1) return null;
    return (
      convertSlaTime(time, {
        fixingSeconds: true,
      }) || "-"
    );
  }, [time]);
      
  return (
    <>
      <Col>
        <div className="title-ticket-type">{props?.processsData?.name}</div>{" "}
        <div>
          <span className="input-ticket">{t("Protocol")}: </span>
          <span className="label-ticket">{props?.processsData?.protocol} </span>

          {!props?.invisibleSLA && (
            <>
              <svg
                style={{ marginRight: "10px", marginLeft: "10px" }}
                width="1"
                height="20"
                viewBox="0 0 1 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  x1="0.5"
                  y1="20"
                  x2="0.5"
                  stroke="white"
                  stroke-opacity="0.15"
                />
              </svg>
              <span className="input-ticket">SLA: </span>
              <span className="label-ticket">
                {timeF}
              </span>
            </>
          )}
        </div>
        <div className="h-100 w-100">
          <ol className="steps h-100 w-100">
            {props?.processsData?.finished === null &&
            props?.processsData?.progress === null ? (
              <li className="step is-active" data-step="1">
                <span className="icon-active">
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 12C10.206 12 12 10.206 12 8C12 5.794 10.206 4 8 4C5.794 4 4 5.794 4 8C4 10.206 5.794 12 8 12ZM8 6C9.103 6 10 6.897 10 8C10 9.103 9.103 10 8 10C6.897 10 6 9.103 6 8C6 6.897 6.897 6 8 6Z"
                      fill="#556EE6"
                    />
                    <path
                      d="M7.42009 19.814C7.59409 19.938 7.79709 20 8.00009 20C8.20309 20 8.40609 19.938 8.58009 19.814C8.88409 19.599 16.0291 14.44 16.0001 8C16.0001 3.589 12.4111 0 8.00009 0C3.58909 0 8.80377e-05 3.589 8.80377e-05 7.995C-0.028912 14.44 7.11609 19.599 7.42009 19.814ZM8.00009 2C11.3091 2 14.0001 4.691 14.0001 8.005C14.0211 12.443 9.61209 16.428 8.00009 17.735C6.38909 16.427 1.97909 12.441 2.00009 8C2.00009 4.691 4.69109 2 8.00009 2Z"
                      fill="#556EE6"
                    />
                  </svg>
                </span>
              </li>
            ) : props?.processsData?.start != null ? (
              <li className="step is-complete" data-step="3"></li>
            ) : (
              <li className="step" data-step="3"></li>
            )}

            {props?.processsData?.finished === null &&
            props?.processsData?.progress != null ? (
              <li className="progress-center step is-active " data-step="2">
                <span className="icon-active">
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 12C10.206 12 12 10.206 12 8C12 5.794 10.206 4 8 4C5.794 4 4 5.794 4 8C4 10.206 5.794 12 8 12ZM8 6C9.103 6 10 6.897 10 8C10 9.103 9.103 10 8 10C6.897 10 6 9.103 6 8C6 6.897 6.897 6 8 6Z"
                      fill="#556EE6"
                    />
                    <path
                      d="M7.42009 19.814C7.59409 19.938 7.79709 20 8.00009 20C8.20309 20 8.40609 19.938 8.58009 19.814C8.88409 19.599 16.0291 14.44 16.0001 8C16.0001 3.589 12.4111 0 8.00009 0C3.58909 0 8.80377e-05 3.589 8.80377e-05 7.995C-0.028912 14.44 7.11609 19.599 7.42009 19.814ZM8.00009 2C11.3091 2 14.0001 4.691 14.0001 8.005C14.0211 12.443 9.61209 16.428 8.00009 17.735C6.38909 16.427 1.97909 12.441 2.00009 8C2.00009 4.691 4.69109 2 8.00009 2Z"
                      fill="#556EE6"
                    />
                  </svg>
                </span>
              </li>
            ) : props?.processsData?.progress != null ? (
              <li
                className="progress-center step is-complete "
                data-step="3"
              ></li>
            ) : (
              <li className="progress-center step " data-step="3"></li>
            )}

            {props?.processsData?.finished != null &&
            props?.processsData?.progress != null ? (
              <li className="step is-active" data-step="3">
                <span className="icon-active">
                  <svg
                    width="16"
                    height="20"
                    viewBox="0 0 16 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 12C10.206 12 12 10.206 12 8C12 5.794 10.206 4 8 4C5.794 4 4 5.794 4 8C4 10.206 5.794 12 8 12ZM8 6C9.103 6 10 6.897 10 8C10 9.103 9.103 10 8 10C6.897 10 6 9.103 6 8C6 6.897 6.897 6 8 6Z"
                      fill="#556EE6"
                    />
                    <path
                      d="M7.42009 19.814C7.59409 19.938 7.79709 20 8.00009 20C8.20309 20 8.40609 19.938 8.58009 19.814C8.88409 19.599 16.0291 14.44 16.0001 8C16.0001 3.589 12.4111 0 8.00009 0C3.58909 0 8.80377e-05 3.589 8.80377e-05 7.995C-0.028912 14.44 7.11609 19.599 7.42009 19.814ZM8.00009 2C11.3091 2 14.0001 4.691 14.0001 8.005C14.0211 12.443 9.61209 16.428 8.00009 17.735C6.38909 16.427 1.97909 12.441 2.00009 8C2.00009 4.691 4.69109 2 8.00009 2Z"
                      fill="#556EE6"
                    />
                  </svg>
                </span>
              </li>
            ) : props?.processsData?.finished != null ? (
              <li className="step is-complete" data-step="3"></li>
            ) : (
              <li className="step" data-step="3"></li>
            )}
          </ol>
        </div>
        <div className="row">
          <div className="col-4 text-left">
            <div className="mt-2 primary-text-progress-hr">{t("Start")}</div>
            <div className="second-text-progress">
              {props?.processsData?.start
                ? moment(props?.processsData?.start).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )
                : " "}
            </div>
          </div>

          <div className="col-4 text-center">
            <div className="mt-2 primary-text-progress-hr">
              {t("In progress")}
            </div>
            <div className="second-text-progress">
              {props?.processsData?.progress
                ? moment(props?.processsData?.progress).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )
                : " "}
            </div>
          </div>

          <div className="col-4 text-right">
            <div className="mt-2 primary-text-progress-hr">{t("Finished")}</div>
            <div className="second-text-progress">
              {props?.processsData?.finished
                ? moment(props?.processsData?.finished).format(
                    "DD/MM/YYYY HH:mm:ss"
                  )
                : " "}
            </div>
          </div>
        </div>
      </Col>
    </>
  );
};
export default withTranslation()(React.memo(HorizontalTimeline));
